/**
 * Ultra Simple Marquee Ticker
 * Uses a CSS-only approach for animation with minimal JavaScript
 * Avoids all issues with conflicting animations and timing problems
 */

(function() {
  // Track which tickers we've initialized to prevent duplicates
  const initializedTickers = new Set();

  // Debug mode
  const DEBUG = true;

  function debug(message, data) {
    if (DEBUG) {
      console.log('[Marquee] ' + message, data !== undefined ? data : '');
    }
  }

  // Main setup function
  function setupMarquees() {
    debug('Setting up marquees');
    
    // Find all marquee sections
    const tickers = document.querySelectorAll('[data-ticker-text]');
    
    tickers.forEach(ticker => {
      // If ticker doesn't have ID, create one
      if (!ticker.id) {
        ticker.id = 'ticker-' + Math.random().toString(36).substr(2, 9);
      }
      
      // Skip if already initialized
      if (initializedTickers.has(ticker.id)) {
        debug('Ticker already initialized, skipping', ticker.id);
        return;
      }
      
      debug('Setting up ticker', ticker.id);
      
      // Mark as initialized
      initializedTickers.add(ticker.id);
      
      // Get the parent frame with speed setting
      const frame = ticker.closest('[data-ticker-frame]');
      if (!frame) {
        debug('No ticker frame found, skipping');
        return;
      }
      
      // Get direction
      const isRightToLeft = ticker.classList.contains('ticker-rtl');
      
      // Get and sanitize speed setting
      const speedSetting = parseInt(frame.getAttribute('data-marquee-speed') || 100, 10);
      
      // Convert speed setting to seconds for animation
      // Higher number in Shopify means slower
const speedMap = {
  20: 8,    // Super fast
  40: 12,   // Very fast
  60: 16,   // Fast
  80: 20,   // Medium-fast
  100: 30,  // Default (medium)
  120: 40,  // Medium-slow
  140: 50,  // Slow
  160: 60,  // Slower
  180: 70,  // Very slow
  200: 80,  // Super slow
  220: 90,  // Extremely slow
  240: 100, // Glacially slow
  260: 120, // Nearly stopped
  280: 140, // Barely moving
  300: 160  // Slowest possible
};
      
      // Find the closest speed setting
      const speeds = Object.keys(speedMap).map(Number);
      const closestSpeed = speeds.reduce((prev, curr) => {
        return (Math.abs(curr - speedSetting) < Math.abs(prev - speedSetting) ? curr : prev);
      });
      
      const duration = speedMap[closestSpeed];
      debug('Setting duration', duration + 's', 'for speed', speedSetting);
      
      // Setup content first
      setupTickerContent(ticker, isRightToLeft);
      
      // Remove any existing animation to prevent conflicts
      ticker.style.animation = 'none';
      
      // Force reflow
      void ticker.offsetWidth;
      
      // Apply animation using inline styles (more reliable than classes)
      const animationName = isRightToLeft ? 'simpleMarqueeRTL' : 'simpleMarqueeLTR';
      ticker.style.animation = `${animationName} ${duration}s linear infinite`;
      
      // Setup pause on hover if needed
      const section = ticker.closest('[data-section-type="marquee"]');
      if (section && section.hasAttribute('data-pause-on-hover')) {
        section.addEventListener('mouseenter', function() {
          ticker.style.animationPlayState = 'paused';
        });
        
        section.addEventListener('mouseleave', function() {
          ticker.style.animationPlayState = 'running';
        });
      }
    });
  }

  // Set up content for seamless scrolling
  function setupTickerContent(ticker, isRightToLeft) {
    debug('Setting up ticker content');
    
    // First, save all original ticker items
    const originalItems = Array.from(ticker.querySelectorAll('.top-bar__ticker'));
    
    if (!originalItems.length) {
      debug('No ticker items found');
      return;
    }
    
    debug('Found original items:', originalItems.length);
    
    // Clear ticker content
    ticker.innerHTML = '';
    
    // Create first container
    const container1 = document.createElement('div');
    container1.className = 'ticker-container';
    container1.style.display = 'inline-flex';
    container1.style.whiteSpace = 'nowrap';
    
    // Add original items to first container
    originalItems.forEach(item => {
      const clone = item.cloneNode(true);
      clone.style.marginRight = '135px';
      container1.appendChild(clone);
    });
    
    // Add first container to ticker
    ticker.appendChild(container1);
    
    // Create second container (identical to first for seamless loop)
    const container2 = container1.cloneNode(true);
    ticker.appendChild(container2);
    
    debug('Set up content with two identical containers');
  }

  // Initialize on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    debug('DOMContentLoaded triggered');
    setupMarquees();
  });

  // Also initialize on window load to ensure all assets are loaded
  window.addEventListener('load', function() {
    debug('Window load triggered');
    // Small delay to ensure everything is fully rendered
    setTimeout(function() {
      setupMarquees();
    }, 100);
  });

  // Handle Shopify theme editor events
  document.addEventListener('shopify:section:load', function(event) {
    debug('Shopify section load triggered');
    
    // Clear from initialized list
    const tickers = event.target.querySelectorAll('[data-ticker-text]');
    tickers.forEach(ticker => {
      initializedTickers.delete(ticker.id);
    });
    
    // Re-setup
    setupMarquees();
  });

  // Handle section selection
  document.addEventListener('shopify:section:select', function(event) {
    debug('Shopify section select triggered');
    if (event.target.getAttribute('data-section-type') === 'marquee') {
      setupMarquees();
    }
  });

  // Handle block selection events
  document.addEventListener('shopify:block:select', function(event) {
    debug('Shopify block select triggered');
    const section = event.target.closest('[data-section-type="marquee"]');
    if (!section) return;
    
    const tickers = section.querySelectorAll('[data-ticker-text]');
    tickers.forEach(ticker => {
      ticker.style.animationPlayState = 'paused';
    });
  });

  // Handle block deselection events
  document.addEventListener('shopify:block:deselect', function(event) {
    debug('Shopify block deselect triggered');
    const section = event.target.closest('[data-section-type="marquee"]');
    if (!section) return;
    
    const tickers = section.querySelectorAll('[data-ticker-text]');
    tickers.forEach(ticker => {
      ticker.style.animationPlayState = 'running';
    });
  });
})();